import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { Autocomplete, Select } from 'core/components';
import { IAutocompleteOption, IOption } from 'core/types';
import { manufacturerService } from 'parts/services';
import { IManufacturer } from 'parts/types';

interface IProps extends ICellRendererParams {
  options?: IOption[];
  isAlternateVersionEnabled?: boolean;
}

const AssignManufacturerCell = ({
  options = [],
  value,
  setValue,
  isAlternateVersionEnabled,
}: IProps) => {
  const { t } = useTranslation();

  const onAssignManufacturerChange = (_, manufacturer: IManufacturer | IAutocompleteOption) => {
    setValue(manufacturer);
  };

  if (options.length > 0) {
    return (
      <Select
        value={value}
        placeholder={t('placeholderChooseManufacturer')}
        onChange={onAssignManufacturerChange}
        options={options}
        getLabel={(option) => option.name}
      />
    );
  }

  return (
    <Autocomplete
      key={value}
      name="manufacturer"
      placeholder={t('placeholderChooseManufacturer')}
      defaultOptions={options || []}
      getOptions={options.length > 0 ? null : manufacturerService.getMany}
      requestPayload={{ alternateVersionEnabled: isAlternateVersionEnabled ? 1 : 0 }}
      getLabel={(option) => option.name}
      value={value}
      onChange={onAssignManufacturerChange}
    />
  );
};

export default AssignManufacturerCell;
